import { Divider, Grid, Stack, Typography } from "@mui/material";
import { useEffect } from "react";
import getItem from "../../../api/auth/items/getItem";
import { useParams } from "react-router-dom";
import PageLoading from "../../../components/layout/PageLoading";
import ItemForm from "../../../components/form/item/ItemForm";
import index from "../../../api/auth/items/itemBookableDurations";
import useBookableDurationStore from "../../../stores/useBookableDurationStore";
import ItemBookableDurations from "../../../components/form/item/ItemBookableDurations";
import ItemAvailability from "../../../components/form/item/ItemAvailability";
import useItemStore from "../../../stores/useItemStore";
import ItemWaiversForm from "../../../components/form/item/ItemWaiversForm";


export default function Item() {
  const { updateItem, itemById } = useItemStore();

  const { setItemBookableDurations } = useBookableDurationStore();

  const { id } = useParams();

  const item = itemById(id);

  useEffect(() => {
    getItem(id, (response) => {
      updateItem(response);
    });
  }, []);

  useEffect(() => {
    index(id, (response) => {
      setItemBookableDurations(response);
    });
  }, []);

  if(!item) return <PageLoading />;

  return (
    <Stack>
      <Grid container spacing={4}>
        <Grid item xs={12} xl={6}>
          <Stack>
            <ItemBookableDurations item={item} />
          </Stack>
        </Grid>
        <Grid item xs={12} xl={6}>
          <Stack mb={2}>
            <Typography variant="h4">
              Edit Item
            </Typography>
          </Stack>
          <Divider sx={{ mb: 2 }} />
          <ItemForm item={item} showImage />
          <Divider sx={{ my: 2 }} />
          <ItemWaiversForm item={item} />
          <Divider sx={{ my: 2 }} />
          <Stack>
            <ItemAvailability item={item} />
          </Stack>
        </Grid>
      </Grid>
    </Stack>
  );
}